import type { ExplorationVolume } from '../types/exploration';

const STATUS_PRIORITY: Record<string, number> = {
  managed: 0,
  monitored: 1,
  unmonitored: 2,
  unattached: 3,
};

function dedupeKey(v: ExplorationVolume, index: number): string {
  if (v.ebsId) return v.ebsId;
  return `missing:${v.accountId || 'unknown'}:${index}`;
}

export function dedupeByEbsId(vols: ExplorationVolume[]): ExplorationVolume[] {
  const m = new Map<string, ExplorationVolume>();
  vols.forEach((v, index) => {
    const k = dedupeKey(v, index);
    const existing = m.get(k);
    if (!existing) {
      m.set(k, v);
      return;
    }
    const newPri = STATUS_PRIORITY[v.status] ?? 99;
    const oldPri = STATUS_PRIORITY[existing.status] ?? 99;
    if (newPri < oldPri) m.set(k, v);
  });
  return [...m.values()];
}
